.searchContainer {
  width: 100%;
  max-width: 1600px;
  margin-inline: auto;
  min-height: 184px;
  background-color: var(--pgm-sys-color-surface-container-low);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
  margin-top: var(--pgm-sys-spacing-10);
  border-radius: var(--pgm-sys-spacing-4);
}

.searchContainerCollapsed {
  min-height: 0;
  padding-block: var(--pgm-sys-spacing-3);
}

.titleContainer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-4);
  margin-bottom: var(--pgm-sys-spacing-6);
}

.titleContainerCollapsed {
  align-items: center;
  margin-bottom: var(--pgm-sys-spacing-0);
}

.titleText {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.title {
  color: var(--pgm-sys-color-on-surface);
}

.title,
.subtitle {
  margin: var(--pgm-sys-spacing-0);
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
}

.collapseButton {
  flex-shrink: 0;
}

.collapseIcon,
.searchIcon {
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-typescale-title-small-line-height);
}

.form {
  display: flex;
  width: 100%;
  gap: var(--pgm-sys-spacing-6);
}

.formInput {
  flex: 1 1 0;
  min-width: 0;
}

.submitButton {
  align-self: center;
  flex-shrink: 0;
}

.initialMessage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--pgm-sys-spacing-6);
  width: 100%;
  max-width: 1600px;
  min-height: 152px;
  margin: var(--pgm-sys-spacing-6) auto var(--pgm-sys-spacing-16);
  padding-block: var(--pgm-sys-spacing-10);
  text-align: center;
}

.initialMessageIcon {
  width: var(--pgm-sys-spacing-16);
  height: var(--pgm-sys-spacing-16);
  color: var(--pgm-sys-color-outline);
  font-size: var(--pgm-sys-spacing-16);
  line-height: var(--pgm-sys-spacing-16);
}

.initialMessageText {
  color: var(--pgm-sys-color-on-surface-variant);
}

.initialMessageText p {
  margin: var(--pgm-sys-spacing-0);
}

.resultsContainer {
  width: 100%;
  max-width: 1600px;
  margin: var(--pgm-sys-spacing-6) auto var(--pgm-sys-spacing-16);
  color: var(--pgm-sys-color-on-surface);
}

.resultsContainer:empty {
  display: none;
}

.loadingState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--pgm-sys-spacing-4);
  min-height: clamp(240px, 45vh, 480px);
  color: var(--pgm-sys-color-on-surface-variant);
  text-align: center;
}

.loadingIndicator {
  width: var(--pgm-sys-spacing-12);
  height: var(--pgm-sys-spacing-12);
  box-sizing: border-box;
  border: var(--pgm-sys-spacing-1) solid var(--pgm-sys-color-surface-container-highest);
  border-top-color: var(--pgm-sys-color-primary);
  border-radius: 50%;
  animation: loadingRotation 800ms linear infinite;
}

.loadingText {
  margin: var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface-variant);
}

@keyframes loadingRotation {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loadingIndicator {
    animation-duration: 1600ms;
  }
}

.contributorSummary {
  display: flex;
  width: 100%;
  max-width: 1600px;
  margin: var(--pgm-sys-spacing-6) auto;
  align-items: center;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-6);
  color: var(--pgm-sys-color-on-surface);
}

.contributorData {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.contributorIdentity {
  text-transform: uppercase;
}

.installmentCount {
  color: var(--pgm-sys-color-on-surface-variant);
}

.paymentRequestWarning {
  display: flex;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  border-radius: var(--pgm-sys-spacing-1);
  background: var(--pgm-sys-color-warning-container);
  color: var(--pgm-sys-color-on-warning-container);
}

.paymentRequestWarningIcon {
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  flex: 0 0 var(--pgm-sys-spacing-4);
  font-size: var(--pgm-sys-spacing-4);
  line-height: var(--pgm-sys-spacing-4);
}

@media (max-width: 768px) {
  .form {
    flex-direction: column;
  }

  .formInput {
    flex: 0 0 auto;
    width: 100%;
  }

  .contributorSummary {
    align-items: stretch;
    flex-direction: column;
  }
}
